import { render, staticRenderFns } from "./ForceRTS.vue?vue&type=template&id=80b24176&scoped=true&"
import script from "./ForceRTS.vue?vue&type=script&lang=js&"
export * from "./ForceRTS.vue?vue&type=script&lang=js&"
import style0 from "./ForceRTS.vue?vue&type=style&index=0&id=80b24176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b24176",
  null
  
)

export default component.exports